export { default } from './GridPageEventOrganizers.vue'
